



























import Vue from "vue";
import { PPCustomerInfo } from "@/picking-portal/models/PPCustomerInfo";
import { userService } from "@/picking-portal/services/PPUserService";

export default Vue.extend({
  name: "PPCustomerInfoComponent",
  props: {
    customerId: {
      type: String,
      required: true,
    },
    transactionId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true as boolean,
      customerInfo: {} as PPCustomerInfo,
    };
  },
  async mounted() {
    this.customerInfo = await userService.getUserInfo(this.customerId);
    this.isLoading = false;
  },
});
